var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKdlaunch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KDLAUNCH",
    transform: "translate(-805 -6237)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71532",
    "data-name": "Group 71532",
    transform: "translate(805 6237)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64962",
    "data-name": "Path 64962",
    d: "M6.476,7.6v6.678H0v3.636H.01v6.7H3.589v-6.7h6.462V7.6Z",
    transform: "translate(0 5.7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64963",
    "data-name": "Path 64963",
    d: "M33.718,14.967v6.682H27.246v3.633h.01v6.7h3.577v-6.7H37.3V14.967Z",
    transform: "translate(19.703 11.225)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64964",
    "data-name": "Path 64964",
    d: "M10.361,18.584v6.68H3.891v3.631H3.9v6.7H7.477v-6.7h6.465V18.584Z",
    transform: "translate(2.814 13.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64965",
    "data-name": "Path 64965",
    d: "M29.822,3.75v6.683H23.348v3.631h.01v6.7h3.579v-6.7H33.4V3.75Z",
    transform: "translate(16.884 2.812)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64966",
    "data-name": "Path 64966",
    d: "M15.272,0V6.68h6.476v3.635h-.014v6.7H18.157v-6.7H11.695V0Z",
    transform: "translate(8.457)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64967",
    "data-name": "Path 64967",
    d: "M40.108,15.048H33.529v6.575H29.952v-.01h-6.6V17.981h6.6V11.415H40.108Z",
    transform: "translate(16.887 8.561)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64968",
    "data-name": "Path 64968",
    d: "M16.758,18.818H10.177v6.576H6.6V25.38H0V21.747H6.6V15.185H16.758Z",
    transform: "translate(0 11.389)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64969",
    "data-name": "Path 64969",
    d: "M19.022,22.275v6.683h6.472v3.633h-.01v6.7H21.906v-6.7H15.441V22.275Z",
    transform: "translate(11.166 16.706)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64970",
    "data-name": "Path 64970",
    d: "M7.664,29.8H14.61v6.575h3.581v-.011h6.462V32.729H18.191V26.166H7.664Z",
    transform: "translate(5.542 19.625)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64971",
    "data-name": "Path 64971",
    d: "M19.555,25.911h6.579v6.573h3.577v-.01h6.75V28.841h-6.75V22.275H19.555Z",
    transform: "translate(14.141 16.706)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64972",
    "data-name": "Path 64972",
    d: "M3.758,7.523h6.577V14.1h3.576v-.014H21.05V10.453H13.911V3.892H3.758Z",
    transform: "translate(2.718 2.919)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64973",
    "data-name": "Path 64973",
    d: "M21.923,10.208V3.633H15.441V0H25.5V6.563h7.223V10.2",
    transform: "translate(11.166)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64974",
    "data-name": "Path 64974",
    d: "M11.169,11.412H7.578v3.647h3.591Z",
    transform: "translate(5.48 8.559)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64975",
    "data-name": "Path 64975",
    d: "M26.941,18.787H23.352v3.647h3.589Z",
    transform: "translate(16.887 14.09)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64976",
    "data-name": "Path 64976",
    d: "M22.79,7.642H19.2v3.645H22.79Z",
    transform: "translate(13.884 5.732)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64977",
    "data-name": "Path 64977",
    d: "M15.286,22.275H11.695v3.647h3.591Z",
    transform: "translate(8.457 16.706)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKdlaunch);
export default __webpack_public_path__ + "static/media/kdlaunch.724f673f340987fe13db150000ee4446.svg";
export { ForwardRef as ReactComponent };